import React from 'react';
import cn from 'clsx';
import PropTypes from 'prop-types';

import Tooltip from '../../library/tooltip/tooltip';
import TireComparison from './components/tire-comparison/tire-comparison';
import CloudShowersHeavyRegularIcon from '../../shared/icons/cloud-showers-heavy-regular-icon';
import SunBrightRegularIcon from '../../shared/icons/sun-bright-regular-icon';

import styles from './stopping-distance-info.scss';

function StoppingDistanceInfo(props) {
  const {
    className = '',
    currentDistance = 0,
    currentRating,
    currentWornDistance = 0,
    icon,
    isDry = false,
    isLT = false,
    isWet = false,
    recommendedDistance = 0,
    recommendedProductLabel,
    recommendedProductUrl,
    recommendedRating,
    recommendedWornDistance = 0,
    title: titleProp,
    tooltip
  } = props;

  const title =
    titleProp || `Stopping Distance on ${isWet ? 'Wet' : 'Dry'} Roads`;
  const defaultIcon = isWet
    ? CloudShowersHeavyRegularIcon
    : SunBrightRegularIcon;
  const Icon = icon || defaultIcon;

  return (
    <div
      className={cn(styles['container'], `stopping-distance-info ${className}`)}
    >
      <div className={styles['wrapper-title']}>
        {Icon && <Icon className={styles['icon']} />}
        <span className={styles['title']}>{title}</span>
        {tooltip && <Tooltip content={tooltip} />}
      </div>

      <TireComparison
        currentDistance={currentDistance}
        currentRating={currentRating}
        currentWornDistance={currentWornDistance}
        isDry={isDry}
        isLT={
          isLT ||
          Math.max(
            250,
            currentDistance,
            currentWornDistance,
            recommendedDistance,
            recommendedWornDistance
          ) > 250
        }
        isWet={isWet}
        recommendedDistance={recommendedDistance}
        recommendedProductLabel={recommendedProductLabel}
        recommendedProductUrl={recommendedProductUrl}
        recommendedRating={recommendedRating}
        recommendedWornDistance={recommendedWornDistance}
      />
    </div>
  );
}

StoppingDistanceInfo.propTypes = {
  className: PropTypes.string,
  currentDistance: PropTypes.number,
  currentRating: PropTypes.number,
  currentWornDistance: PropTypes.number,
  icon: PropTypes.func,
  isDry: PropTypes.bool,
  isLT: PropTypes.bool,
  isWet: PropTypes.bool,
  recommendedDistance: PropTypes.number,
  recommendedProductLabel: PropTypes.string,
  recommendedProductUrl: PropTypes.string,
  recommendedRating: PropTypes.number,
  recommendedWornDistance: PropTypes.number,
  title: PropTypes.string,
  tooltip: PropTypes.string
};

export default StoppingDistanceInfo;
